import { Typography } from "@mui/material";

export default function NoEntries () {
  return (
    <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: '50vh'}}>
      <Typography variant="h6" style={{textAlign: `center`}}>
          <p>
            There are no entries that match your current filter. Please amend your selection.
          </p>
      </Typography>
    </div>
  )
}
